export enum GameCardContainerType {
  Box = 'box',
  Tall = 'tall',
  Wide = 'wide',
}
